import {range} from 'ramda';

import {isTimeType, TimeType} from '../../../types/TimeType';

const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;

export const DEFAULT_TIME_PICKER_STEP = 15;

export function getTimeOptions(step: 1 | 5 | 10 | 15 | 30 = DEFAULT_TIME_PICKER_STEP): TimeType[] {
  return range(0, (HOURS_PER_DAY * MINUTES_PER_HOUR) / step)
    .map((index) => {
      const minutesOfDay = index * step;
      const hour = String(Math.floor(minutesOfDay / MINUTES_PER_HOUR)).padStart(2, '0');
      const minute = String(minutesOfDay % MINUTES_PER_HOUR).padStart(2, '0');
      return `${hour}:${minute}`;
    })
    .filter(isTimeType);
}
